export const directions = {
    ASC: "ASC",
    DESC: "DESC",
};

const compare = (a, b) => {
    if (!a && a !== 0) return -1;
    if (!b && b !== 0) return 1;
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
};

const reverseSortDirection = (direction) =>
    direction === directions.ASC ? directions.DESC : directions.ASC;

export const getNewDirection = (previousColumn, newColumn, currentDirection) =>
    previousColumn === newColumn
        ? reverseSortDirection(currentDirection)
        : directions.ASC;

const getValue = (obj, key) =>
    key.split(".").reduce((acc, part) => acc?.[part], obj);

export const sortByColumn = (list, column, direction) =>
    !column || !direction
        ? list.slice(0)
        : [...list].sort((a, b) => {
              const [valA, valB] = [getValue(a, column), getValue(b, column)];
              return direction === directions.DESC
                  ? compare(valB, valA)
                  : compare(valA, valB);
          });
